var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.7 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.31,40C4.17,37.44.08,34.12,0,27.69c-.09-8,5.58-13.19,14-12.51v6c-.89.2-1.83.39-2.76.64C8,22.7,6.54,24.88,7,28.14s2.81,5.55,5.82,4.65c2.16-.65,5.07-3.36,5.22-5.33.6-7.95.27-16,.28-24,0-1.17,0-2.33,0-3.5h7c-.11,4.16,1.89,7.39,5.62,8.56,4.69,1.48,4.12,4.16,3,8l-8.56-2.29C24.7,23.71,28,34.57,16.31,40Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.01eaddb0a60797b3f77b0aa244408b1e.svg";
export { ForwardRef as ReactComponent };